/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/handwritten-web-development-notes",
  title: "Handwritten web development notes",
  description: `My handwritten Web Development notes ✍️

🧵👇`,
  image: "/covers/threads/handwritten-web-development-notes.png",
  author: "Pratham"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ol: "ol",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Pratham",
      username: "Prathkum",
      avatarUrl: "/avatars/Prathkum.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/Prathkum/status/1384780558165680135"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "My handwritten Web Development notes ✍️"
      }), _jsx(_components.p, {
        children: "🧵👇"
      })]
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-1.png`,
      children: _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "CSS selectors ☑️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-2.png`,
      children: _jsxs(_components.ol, {
        start: "2",
        children: ["\n", _jsx(_components.li, {
          children: "Some important CSS Pseudo classes 🔯"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-3.png`,
      children: _jsxs(_components.ol, {
        start: "3",
        children: ["\n", _jsx(_components.li, {
          children: "Box model ◻️▫️▪️🔲🔳"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-4.png`,
      children: _jsxs(_components.ol, {
        start: "4",
        children: ["\n", _jsx(_components.li, {
          children: "Display property ➖"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-5.png`,
      children: _jsxs(_components.ol, {
        start: "5",
        children: ["\n", _jsx(_components.li, {
          children: "Justify-content and align-content explained ⬅️⬇️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-6.png`,
      children: _jsxs(_components.ol, {
        start: "6",
        children: ["\n", _jsx(_components.li, {
          children: "Align-items and align-self explained 📊"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-7.png`,
      children: _jsxs(_components.ol, {
        start: "7",
        children: ["\n", _jsx(_components.li, {
          children: "Axes of a layout container ⬆️➡️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-8.png`,
      children: _jsxs(_components.ol, {
        start: "8",
        children: ["\n", _jsx(_components.li, {
          children: "z-index - stacking order of elements 🏗️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-9.png`,
      children: _jsxs(_components.ol, {
        start: "9",
        children: ["\n", _jsx(_components.li, {
          children: "Give your element a 3D look wit1h CSS perspective property 👀🕶️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-10.png`,
      children: _jsxs(_components.ol, {
        start: "10",
        children: ["\n", _jsx(_components.li, {
          children: "Alignment in CSS 🗄️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-11.png`,
      children: _jsxs(_components.ol, {
        start: "11",
        children: ["\n", _jsx(_components.li, {
          children: "Quick start guide to Grid layout 🧮"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-12.png`,
      children: _jsxs(_components.ol, {
        start: "12",
        children: ["\n", _jsx(_components.li, {
          children: "Position property CSS ⏹️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-13.png`,
      children: _jsxs(_components.ol, {
        start: "13",
        children: ["\n", _jsx(_components.li, {
          children: "Grid cheat sheet 📃"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-14.png`,
      children: _jsxs(_components.ol, {
        start: "14",
        children: ["\n", _jsx(_components.li, {
          children: "Flexbox cheat sheet 📄"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-15.png`,
      children: _jsxs(_components.ol, {
        start: "15",
        children: ["\n", _jsx(_components.li, {
          children: "animation-timing-function 📉📈"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-16.png`,
      children: _jsxs(_components.ol, {
        start: "16",
        children: ["\n", _jsx(_components.li, {
          children: "Don't use \"solid\" border always 🖼️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-17.png`,
      children: _jsxs(_components.ol, {
        start: "17",
        children: ["\n", _jsx(_components.li, {
          children: "Git workflow 🌊📲"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-18.png`,
      children: _jsxs(_components.ol, {
        start: "18",
        children: ["\n", _jsx(_components.li, {
          children: "JavaScript Array methods cheat sheet Ⓜ️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-19.png`,
      children: _jsxs(_components.ol, {
        start: "19",
        children: ["\n", _jsx(_components.li, {
          children: "JavaScript Date methods 📅🗓️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-20.png`,
      children: _jsxs(_components.ol, {
        start: "20",
        children: ["\n", _jsx(_components.li, {
          children: "What is a functions 🧩"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-21.png`,
      children: _jsxs(_components.ol, {
        start: "21",
        children: ["\n", _jsx(_components.li, {
          children: "Arrow functions ➡️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-22.png`,
      children: _jsxs(_components.ol, {
        start: "22",
        children: ["\n", _jsx(_components.li, {
          children: "Document Object Model 🌳"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-23.png`,
      children: _jsxs(_components.ol, {
        start: "23",
        children: ["\n", _jsx(_components.li, {
          children: "addEventListener method 🎤"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-24.png`,
      children: _jsxs(_components.ol, {
        start: "24",
        children: ["\n", _jsx(_components.li, {
          children: "Font shorthand property 🔠"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-25.png`,
      children: _jsxs(_components.ol, {
        start: "25",
        children: ["\n", _jsx(_components.li, {
          children: "justify-items | align-items | justify-content | align-content 🟥🟦◻️▪️"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handwritten-web-development-notes-26.png`,
      children: _jsxs(_components.ol, {
        start: "26",
        children: ["\n", _jsx(_components.li, {
          children: "Array methods [◽◾◽◾]"
        }), "\n"]
      })
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
